import { module } from 'angular';
import App from '../../app';
import * as _ from 'lodash';

class PopupService {
	
	constructor($q, $compile, $uibModal) {
		this.$q = $q;
		this.$compile = $compile;
		this.$uibModal = $uibModal;
		this.modal = ['START'];
		this.alert = [];
		this.confirm = [];
		this.loadingBar = null;
	}

	showLoadingBar(scope) {
		const $body = $('body');
		const fontSize = 150;
		const { top, left } = this.calculatePosition(fontSize, fontSize);
		const template = `
			<div class="dim" style="z-index:99999">
				<i class="bxd bxd-setting bxd-spin" 
					style="position: relative; top:${top}px; left:${left}px; color: white; font-size:${fontSize}px; width:${fontSize}px; height:${fontSize}px;"></i>
			</div>
		`;
		
		this.loadingBar = this.$compile(template)(scope); 
		$body.append(this.loadingBar);
	}
	
	closeLoadingBar() {
		this.loadingBar && this.loadingBar.remove();
	}
	
	showSmallLoadingBar(scope, top, left, color) {
		const $body = $('body');
		const fontSize = 20;
		let fontColor = color ? color: '#000';
		const template = `
			<div class="transparent-dim" style="z-index:99999">
				<i class="bxd bxd-setting bxd-spin" 
					style="position: relative; top:${top}px; left:${left}px; color:${fontColor}; font-size:${fontSize}px; width:auto; height:auto; z-index: 9999;"></i>
			</div>
		`;
		
		this.smallLoadingBar = this.$compile(template)(scope); 
		$body.append(this.smallLoadingBar);
	}
	
	closeSmallLoadingBar() {
		this.smallLoadingBar && this.smallLoadingBar.remove();
	}
	
	simpleAlert(scope, text="", close=()=>{}){
		const $body = $('body');
		const width = 460, height = 180;
		const { top, left } = this.calculatePosition(width, height);
		const template = `
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: ${width}px;">
						<h2 class="bw-tt a-center" style="height:auto; max-height: 400px; overflow: auto;">${text}</h2>
						<div class="btn-wrap add-mg-t">
							<button id="simpleAlertConfirm" type="button" class="bw-btn-txt">확인</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		if(this.alert.length > 0){	
			const { $simpleAlert, close } = this.alert.pop();
			close();
			$simpleAlert.remove();
		}
		
		const $simpleAlert = this.$compile(template)(scope); 
		$body.append($simpleAlert);
		this.alert.push({ $simpleAlert, close });

		this.setButtonFocusEvent();

		$('#simpleAlertConfirm').click(()=>{
			close();
			$simpleAlert.remove();
		});
	}
	
	detailAlert(scope, text="", detail="", param="", close=()=>{}){
		const $body = $('body');
		const width = 460, height = 180;
		const { top, left } = this.calculatePosition(width, height);
		
		text = text ? text : '';
		detail = detail ? detail : '';
		param = param ? param : '';
		
		const template = `
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: ${width}px;">
						<h2 class="bw-tt a-center" style="height:auto; max-height: 200px; overflow: auto;">${text}</h2>
						<span style="display: block; font-size: 15px; max-height: 200px; overflow: auto;">${param}</span>
						<div>
							<span id="detailToggle" class="chr-c-blue cs-p">
								상세보기 <i class="bxd bxd-toggle chr-c-blue" style="transform: rotate(180deg);font-size: 12px; width: 12px;"></i>
							</span>
						</div>
						<div id="detailWrapper" style="display: none;" class="detailWrapper">${detail}</div>
						<div class="btn-wrap add-mg-t">
							<button id="detailAlertConfirm" type="button" class="bw-btn-txt">확인</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		if(this.alert.length > 0){
			const { $simpleAlert, close } = this.alert.pop();
			close();
			$simpleAlert.remove();
		}
		
		const $detailAlert = this.$compile(template)(scope); 
		$body.append($detailAlert);
		this.alert.push({ $simpleAlert: $detailAlert, close });
		
		$('#detailAlertConfirm').click(()=>{
			close();
			$detailAlert.remove();
		});
		
		$('#detailToggle').click(() => {
			let $detail = $('#detailWrapper');
			let $toggle = $('#detailToggle>i');
			
			if($detail.is(':visible')) {
				$detail.hide();
				$toggle.css('transform', 'rotate(180deg)');
			}else {
				$detail.show();
				$toggle.css('transform', '');
			}
		});
	}
	
	pdfTest(scope, template){
		const $body = $('body');
		const width = 460, height = 180;
		const { top, left } = this.calculatePosition(width, height);
		
		if(this.alert.length > 0){
			const { $simpleAlert, close } = this.alert.pop();
			close();
			$simpleAlert.remove();
		}
		
		const $simpleAlert = this.$compile(template)(scope); 
		$body.append($simpleAlert);
		this.alert.push({ $simpleAlert, close });
	}
	
	simpleConfirm(scope, text="", confirm=()=>{}, cancel=()=>{}, confirmTxt = '확인', cancelTxt = '취소'){
		const $body = $('body');
		const width = 460, height = 180;
		const { top, left } = this.calculatePosition(width, height);
		const template = `
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: ${width}px;">
						<h2 class="bw-tt a-center" style="height:auto;">${text}</h2>
						<div class="btn-wrap add-mg-t">
							<button id="simpleConfirmOk" type="button" class="bw-btn-txt">${confirmTxt}</button>
							<button id="simpleAlertCancel" type="button" class="bw-btn-txt">${cancelTxt}</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		if(this.confirm.length > 0){
			const { $simpleConfirm } = this.confirm.pop();
			$simpleConfirm.remove();
		}
		
		const $simpleConfirm = this.$compile(template)(scope); 
		$body.append($simpleConfirm);
		this.confirm.push({ $simpleConfirm, cancel });
		
		this.setButtonFocusEvent();

		$('#simpleConfirmOk').click(()=>{
			confirm();
			$simpleConfirm.remove();
		});
		
		$('#simpleAlertCancel').click(()=>{
			cancel();
			$simpleConfirm.remove();
		});
	}
	
	openModal(viewId, data = {}, draggable, resizable){
		let defer = this.$q.defer();
		const templateUrl = `app/views/popup/${viewId}/${viewId}.tpl.html`;
		const controller = `${viewId}Controller`;
		
		$('.ui-tooltip').remove();
		
		const modalInstance = this.$uibModal.open({
			templateUrl: templateUrl,
			controller: controller,
			controllerAs: 'vm',
			resolve: {
				data: () => data
			}
		});
		
		this.modal.push(modalInstance);
		
		modalInstance.rendered
			.then(() => {			
				if(draggable) {
					 $('.simple-modal-wrap').draggable({
		                cancel: '.search-wrap, .btn-wrap, #gridWrap',
		                containment: 'body',
		                cursor: 'auto',
		            });
				}
				
				if(resizable) {
					 $('.simple-modal-wrap').resizable();
				}
			});
		
		modalInstance.result
			.then(result => {
				this.modal.pop();
				defer.resolve(result);
				$('.ui-tooltip').remove();
			})
			.catch(cancel => {
				this.modal.pop();
				defer.reject(cancel);
				$('.ui-tooltip').remove();
			});
		
		modalInstance.closed
			.then(result => {
				$('[aria-describedby]').focusout();
			})
			
		return defer.promise;
	}
	
	calculatePosition(contentWidth, contentHeight) {
		const {innerWidth: width, innerHeight: height} = window;
		
		return { 
			top : Math.round(( height - contentHeight ) / 2), 
			left : Math.round(( width - contentWidth ) / 2)
		}
	}
	
	getModalZIndex(){
		return 1000 + this.modal.length;
	}
	
	batchshowLoadingBar(scope,confirm=()=>{}) {
		const $body = $('body');
		const fontSize = 150;
		const { top, left } = this.calculatePosition(fontSize, fontSize);
		const template = `
			<div class="dim" style="z-index:99999">
				<i class="bxd bxd-setting bxd-spin" 
					style="position: relative; top:${top}px; left:${left}px; color: white; font-size:${fontSize}px; width:${fontSize}px; height:${fontSize}px;"></i>
			</div>
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: 300px;">
						<h2 class="a-center" style="height:auto; max-height: 400px; overflow: auto; font-size:30px; line-height: 60px;">배포중...</h2>
						<h2 class="bw-tt a-center" style="height:auto; max-height: 400px; overflow: auto;">
						전체 &nbsp;&nbsp;:&nbsp;&nbsp;{{vm.listLength}}
						&nbsp;&nbsp;&nbsp;&nbsp;성공&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{{vm.successCnt}}
						&nbsp;&nbsp;&nbsp;&nbsp;실패&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{{vm.failCnt}}
						</h2>
						<div class="btn-wrap add-mg-t">
							<button id="simpleAlertConfirm" type="button" class="bw-btn-txt">배포중단</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		this.loadingBar = this.$compile(template)(scope); 
		$body.append(this.loadingBar);
		
		$('#simpleAlertConfirm').click(()=>{
			confirm();
			this.loadingBar.remove();
		});
	}
	
	batchSaveShowLoadingBar(scope,confirm=()=>{}) {
		const $body = $('body');
		const fontSize = 150;
		const { top, left } = this.calculatePosition(fontSize, fontSize);
		const template = `
			<div class="dim" style="z-index:99999">
				<i class="bxd bxd-setting bxd-spin" 
					style="position: relative; top:${top}px; left:${left}px; color: white; font-size:${fontSize}px; width:${fontSize}px; height:${fontSize}px;"></i>
			</div>
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: 300px;">
						<h2 class="a-center" style="height:auto; max-height: 400px; overflow: auto; font-size:30px; line-height: 60px;">저장중...</h2>
						<h2 class="bw-tt a-center" style="height:auto; max-height: 400px; overflow: auto;">
						전체 &nbsp;&nbsp;:&nbsp;&nbsp;{{vm.listLength}}
						&nbsp;&nbsp;&nbsp;&nbsp;성공&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{{vm.successCnt}}
						&nbsp;&nbsp;&nbsp;&nbsp;실패&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;{{vm.failCnt}}
						</h2>
						<div class="btn-wrap add-mg-t">
							<button id="simpleAlertConfirm" type="button" class="bw-btn-txt">저장중단</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		this.loadingBar = this.$compile(template)(scope); 
		$body.append(this.loadingBar);
		
		$('#simpleAlertConfirm').click(()=>{
			confirm();
			this.loadingBar.remove();
		});
	}
	
	receiveYnConfirm(scope, text="", yes=()=>{}, no=()=>{}, cancel=()=>{}, yesTxt = '예', noTxt = '아니오', cancelTxt = '취소'){
		const $body = $('body');
		const width = 460, height = 180;
		const { top, left } = this.calculatePosition(width, height);
		const template = `
			<div class="dim" style="z-index:99999">
				<div class="simple-modal-wrap" style="top:${top}px; left:${left}px;">
					<div style="width: ${width}px;">
						<h2 class="bw-tt a-center" style="height:auto;">${text}</h2>
						<div class="btn-wrap add-mg-t">
							<button id="yesConfirm" type="button" class="bw-btn-txt">${yesTxt}</button>
							<button id="noConfirm" type="button" class="bw-btn-txt">${noTxt}</button>
							<button id="simpleAlertCancel" type="button" class="bw-btn-txt">${cancelTxt}</button>
						</div>
					</div>
				</div>
			</div>
		`;
		
		if(this.confirm.length > 0){
			const { $simpleConfirm } = this.confirm.pop();
			$simpleConfirm.remove();
		}
		
		const $simpleConfirm = this.$compile(template)(scope); 
		$body.append($simpleConfirm);
		this.confirm.push({ $simpleConfirm, cancel });
		
		$('#yesConfirm').click(()=>{
			yes();
			$simpleConfirm.remove();
		});
		
		$('#noConfirm').click(()=>{
			no();
			$simpleConfirm.remove();
		});
		
		$('#simpleAlertCancel').click(()=>{
			cancel();
			$simpleConfirm.remove();
		});
		
		this.setButtonFocusEvent();
		
		$('#yesConfirm').focus();
	}
	
	setButtonFocusEvent(){
		$('.simple-modal-wrap').eq($('.simple-modal-wrap').length -1).find('button').focus(function(){
			$(event.target).attr('class', 'bw-btn-txt on');
		});
		$('.simple-modal-wrap').eq($('.simple-modal-wrap').length -1).find('button').blur(function(){
			$(event.target).attr('class', 'bw-btn-txt');
		});
		$('.simple-modal-wrap').eq($('.simple-modal-wrap').length -1).find('button').get(0).focus();
	}
}

module(App.name).service('popupService', PopupService);


// WEBPACK FOOTER //
// ./src/app/common/service/popup.service.js